<template>
 <div>
    <SubscribedComponent></SubscribedComponent>
 </div>
</template>

<script>
import SubscribedComponent from '@/components/SubscribedComponent.vue';
export default {
    name: 'SubscribedActive',
    data() {
        return {

        }
    },
    components:{
        SubscribedComponent
    }
}
</script>